import React, { useEffect, useRef } from 'react';
// Register reusable CSS/SVG animations by name. Use in a topic: { type: 'animation', name: 'candles' }
export const ANIMATIONS = {
  candles: () => (<div className="anim candles">{[40, 65, 50, 80, 70, 95].map((h, i) =>
    <i key={i} style={{ '--h': h + '%', '--d': i * 0.15 + 's' }} className={i % 3 === 2 ? 'dn' : 'up'} />)}</div>),
  pulse: () => <div className="anim pulse"><span>XAU</span></div>,
  ticker: () => (<div className="anim ticker"><div>XAUUSD ▲ 2,351.20 · DXY ▼ 104.10 · EURUSD ▲ 1.0912 · XAUUSD ▲ 2,351.20 · DXY ▼ 104.10 · EURUSD ▲ 1.0912 ·</div></div>),
};
// Lottie: { type: 'lottie', src: '/lottie/file.json' } (put JSON in public/lottie/)
export function Lottie({ src, loop = true }) {
  const el = useRef();
  useEffect(() => { let a; import('lottie-web').then(({ default: l }) => {
    a = l.loadAnimation({ container: el.current, renderer: 'svg', loop, autoplay: true, path: src }); });
    return () => a && a.destroy(); }, [src]);
  return <div className="lottie" ref={el} />;
}
